import React from "react";
import ApHeader from "../components/approval/ApHeader";
import ApFooter from "../components/approval/ApFooter";
import ApAnnotationPanel from "../components/approval/ApAnnotationPanel";
import ApMediaDisplay from "../components/approval/ApMediaDisplay";
import ReactCursorPosition from "react-cursor-position";
import ReactTooltip from "react-tooltip";
import ApLine from "../components/approval/ApLine";
import Fullscreen from "react-full-screen";

class PageApprovalDesktop extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      project: props.project,
      media: props.media,
      current: 0,
      total: props.documents.length,
      annoCards: [],
      annotationStates: [],
      markers: [],
      showLines: true,
      viewport: { width: 0, height: 0 },
      editMode: "view",
      rotation: 0
    };

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({
      viewport: { width: window.innerWidth, height: window.innerHeight }
    });
  }

  onHeaderButton(id) {
    switch (id) {
      case "next":
        this.onNavigate(this.state.current + 1);
        break;
      case "prev":
        this.onNavigate(this.state.current - 1);
        break;
      case "fullscreen":
        this.setState({ isFullscreen: true });
        break;
      case "rotate":
        let rotation = this.state.rotation;
        rotation += 90;
        this.setState({ rotation: rotation });
        break;
    }
  }

  onNavigate(newId) {
    if (newId < 0 || newId > this.state.total - 1) return;
    this.setState({
      current: newId,
      markers: [],
      annoCards: [],
      annotationStates: [],
      editMode: "view",
      rotation: 0
    });
  }

  onAnnotationCardCreated(id, ref) {
    let annoCards = this.state.annoCards;

    annoCards.push({ id: id, ref: ref });

    if (id < 3) this.toggleAnnotation(id);

    this.setState({ annoCards: annoCards });
  }

  onMarkerCreated(id, ref) {
    let markers = this.state.markers;

    markers.push({ id: id, ref: ref });

    this.setState({ markers: markers });
  }

  setLines(enabled) {
    if (enabled) this.setState({ showLines: true });
    else this.setState({ showLines: false });
  }

  toggleAnnotation(id) {
    let annotationStates = this.state.annotationStates;

    const newState =
      annotationStates[id] === null ? true : !annotationStates[id];

    annotationStates[id] = newState;

    this.setState({ annotationStates: annotationStates });
  }

  changeEditMode(newMode) {
    const { editMode } = this.state;

    if (editMode === newMode) newMode = "view";

    this.setState({ editMode: newMode });
  }

  onForceUpdate() {
    this.forceUpdate();
  }

  render() {
    const { documents, annotations } = this.props;
    const currentMedia = documents[this.state.current];

    const lines = annotations.map((value, index) => {
      if (
        !this.state.showLines ||
        index >= this.state.markers.length ||
        index >= this.state.annoCards.length ||
        !this.state.annoCards[index].ref ||
        !this.state.annoCards[index].ref.current
      )
        return;

      const marker = this.state.markers[index];

      const boundsStart = this.state.annoCards[
        index
      ].ref.current.getBoundingClientRect();

      const boundsTarget = marker.ref.current.getBoundingClientRect();

      if (boundsTarget.right > this.state.viewport.width - 300) return;

      return (
        <ApLine
          bright={this.state.annotationStates[index]}
          key={index}
          from={{
            x: boundsStart.left,
            y: boundsStart.top + boundsStart.height / 2
          }}
          to={{
            x: boundsTarget.left + boundsTarget.width / 2,
            y: boundsTarget.top + boundsTarget.height / 2
          }}
        />
      );
    });

    return (
      <div className="PageApproval">
        <ApHeader
          onButtonClick={id => this.onHeaderButton(id)}
          label={this.state.project.name}
          editMode={this.state.editMode}
          onEditModeButton={m => this.changeEditMode(m)}
        />
        <ApAnnotationPanel
          toggleAnnotation={id => this.toggleAnnotation(id)}
          onAnnotationCardCreated={(id, ref) =>
            this.onAnnotationCardCreated(id, ref)
          }
          forceUpdate={() => this.forceUpdate()}
          annotations={annotations}
          annotationStates={this.state.annotationStates}
        />
        <ReactCursorPosition className="ReactMouse">
          <ApMediaDisplay
            media={currentMedia}
            annotations={annotations}
            annotationStates={this.state.annotationStates}
            editMode={this.state.editMode}
            setLines={e => this.setLines(e)}
            onForceUpdate={() => this.onForceUpdate()}
            rotation={this.state.rotation}
            onMarkerCreated={(id, ref) => this.onMarkerCreated(id, ref)}
          />
        </ReactCursorPosition>
        <ApFooter
          onButtonClick={id => this.onHeaderButton(id)}
          onNavigate={newId => this.onNavigate(newId)}
          label={`${this.state.current + 1} / ${this.state.total}`}
        />

        {lines}

        <Fullscreen
          enabled={this.state.isFullscreen}
          onChange={isFull => this.setState({ isFullscreen: isFull })}
        >
          {this.state.isFullscreen ? <img src={currentMedia.source} /> : null}
        </Fullscreen>

        <ReactTooltip effect="solid" />
      </div>
    );
  }
}

export default PageApprovalDesktop;



// WEBPACK FOOTER //
// ./src/pages/PageApprovalDesktop.js